/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { ActionModel } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'a[href][kitModel]',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkComponent extends BaseDirective<ActionModel> {

  @HostBinding('class.kit-loading')
  get isLoading(): boolean {
    return this.model && this.model.isLoading;
  }

  get hostClass(): string {
    return 'kit-link';
  }

}
